import { useEffect, useMemo, useState } from "react";
import {
  getPendingCasinoBetExpiresAt,
  getPendingCasinoBetSecondsLeft,
} from "../utils/casinoPendingExpiry";

export function useCasinoPendingExpiry(bet) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!bet?._id) return undefined;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [bet?._id]);

  const expiresAt = useMemo(() => getPendingCasinoBetExpiresAt(bet), [bet]);
  const deadline = expiresAt != null ? new Date(expiresAt).toISOString() : null;
  const secondsLeft = bet ? getPendingCasinoBetSecondsLeft(bet, now) : null;
  const isExpired = secondsLeft === 0;

  return { deadline, secondsLeft, isExpired };
}
